<template>
	<div class="vacancies">
		<b-row>
			<b-col cols="12" md="6" lg="4" v-for="(item, index) in data" :key="index">
				<vacant-card-component :content="item" @showModal="show(item)"></vacant-card-component>
			</b-col>
		</b-row>
		<div class="pagination-container d-flex justify-content-center align-items-center">
			<paginate
				v-if="pages>1"
				:page-count="pages"
				:page-range="3"
				:margin-pages="1"
				:click-handler="clickCallback"
				:prev-text='`<svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
<path
d="M0.137073 7.32271L6.54294 13.8596C6.63461 13.9531 6.7401 14 6.85916 14C6.97828 14 7.08372 13.9531 7.17534 13.8596L7.86254 13.1582C7.95431 13.0647 8 12.9573 8 12.8355C8 12.7138 7.95431 12.6064 7.86254 12.5129L2.46029 6.99985L7.86254 1.48674C7.95431 1.39324 8 1.28564 8 1.16423C8 1.04252 7.95431 0.934919 7.86254 0.841417L7.1753 0.140229C7.08367 0.0466289 6.97823 8.64348e-07 6.85912 8.53935e-07C6.74005 8.43526e-07 6.63461 0.0467271 6.54294 0.140229L0.13741 6.67719C0.0458357 6.77064 -3.31075e-07 6.8783 -3.41702e-07 6.99985C-3.52329e-07 7.12141 0.0454975 7.22901 0.137073 7.32271Z"
fill="#9186A2"/>
</svg>`'
				:next-text='`<svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"
					     style="transform: rotate(180deg)">
						<path
							d="M0.137073 7.32271L6.54294 13.8596C6.63461 13.9531 6.7401 14 6.85916 14C6.97828 14 7.08372 13.9531 7.17534 13.8596L7.86254 13.1582C7.95431 13.0647 8 12.9573 8 12.8355C8 12.7138 7.95431 12.6064 7.86254 12.5129L2.46029 6.99985L7.86254 1.48674C7.95431 1.39324 8 1.28564 8 1.16423C8 1.04252 7.95431 0.934919 7.86254 0.841417L7.1753 0.140229C7.08367 0.0466289 6.97823 8.64348e-07 6.85912 8.53935e-07C6.74005 8.43526e-07 6.63461 0.0467271 6.54294 0.140229L0.13741 6.67719C0.0458357 6.77064 -3.31075e-07 6.8783 -3.41702e-07 6.99985C-3.52329e-07 7.12141 0.0454975 7.22901 0.137073 7.32271Z"
							fill="#9186A2"/>
					</svg>`'
				:container-class="'pagination'"
				:page-class="'page-item'"
				:no-li-surround="true">
			</paginate>
		</div>
		<modal name="card_modal"
		       :height="'auto'"
		       :width="695"
		       :adaptive="true"
		       @before-close="$root.beforeClose()"
		>
			<vacant-modal-component :data="modalData" @closeModal="hide()"></vacant-modal-component>
		</modal>
	</div>
</template>

<script>
	const axios = require('axios');
	export default {
		data() {
			return {
				data: {},
				pages: null,
				modalData: null,
			}
		},
		beforeCreate() {
			axios.get(`${this.$root.routLink}${this.$route.path}?ajax&act=vacancy_pages`,
				{responseType: 'json'}
			).then(({data}) => {
				this.pages = parseInt(JSON.parse(data.addons))
				
				axios.get(`${this.$root.routLink}${this.$route.path}?ajax&act=vacancies`,
					{responseType: 'json'}
				).then(({data}) => {
					this.data = JSON.parse(data.addons)
				})
			})
			
			
		},
		methods: {
			clickCallback(pageNum) {
				axios.get(`${this.$root.routLink}${this.$route.path}page${pageNum}/?ajax&act=vacancies`, {
					params: {
						page: this.page,
					},
					responseType: 'json',
				}).then(({data}) => {
					this.data = JSON.parse(data.addons)
				})
			},
			show(item) {
				this.modalData = item
				this.$modal.show('card_modal')
				this.$root.stopScroll = true
			},
			hide() {
				this.$modal.hide('card_modal')
				this.$root.stopScroll = false
			},
		}
	}
</script>

<style lang="scss" scoped>


</style>